export const convertToRupee = (amount) => amount?.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR'
})